export default class Logger {
  static error = (...message: string[]) => console.error(...message);

  static info = (...message: string[]) => console.info(...message);
}

export const Log = (...message: string[]) => Logger.info(...message);
